import React, { useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { ThemeToggle } from "../components/ThemeToggle";
export function Terms() {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-white dark:bg-gray-900" data-id="element-435">
      <nav className="fixed top-0 w-full bg-white dark:bg-gray-900 border-b dark:border-gray-700 z-50" data-id="element-436">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-437">
          <div className="flex items-center justify-between h-16" data-id="element-438">
            <button onClick={() => navigate("/")} className="text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 transition-colors flex items-center" data-id="element-439">
              <ArrowLeft className="w-5 h-5 mr-2" data-id="element-440" />
              Back to Home
            </button>
            <div className="flex items-center space-x-4" data-id="element-441">
              <ThemeToggle data-id="element-442" />
              <div onClick={() => navigate("/")} className="text-xl font-bold text-blue-600 dark:text-blue-400 cursor-pointer hover:text-blue-700 dark:hover:text-blue-300 transition-colors" data-id="element-443">
                <span data-id="element-444">MVP</span>
                <span data-id="element-445">Hub.co</span>
              </div>
            </div>
          </div>
        </div>
      </nav>
      <main className="pt-32 pb-24" data-id="element-446">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-447">
          <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 p-8 md:p-12" data-id="element-448">
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-8" data-id="element-449">
              Terms and Conditions
            </h1>
            <p className="text-gray-700 dark:text-gray-200 mb-8" data-id="element-450">
              Welcome to MVPHub.co, operated by LeanOps LLC.
            </p>
            <p className="text-gray-700 dark:text-gray-200 mb-8" data-id="element-451">
              Last Updated: February 1, 2025
            </p>
            <p className="text-gray-700 dark:text-gray-200 mb-8" data-id="element-452">
              By using our services, you agree to be bound by these Terms.
            </p>
            <div className="space-y-8" data-id="element-453">
              <section data-id="element-454">
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4" data-id="element-455">
                  1. Business Information
                </h2>
                <div className="text-gray-700 dark:text-gray-200 space-y-2" data-id="element-456">
                  <p data-id="element-457">Legal Entity: LeanOps LLC</p>
                  <p data-id="element-458">
                    Business Address: 16192 Coastal Hwy, Lewes, Delaware 19958
                  </p>
                  <p data-id="element-459">
                    Jurisdiction: These Terms shall be governed by and
                    interpreted in accordance with the laws of the State of
                    Delaware, USA.
                  </p>
                </div>
              </section>
              <section data-id="element-460">
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4" data-id="element-461">
                  2. Services Offered
                </h2>
                <div className="space-y-4" data-id="element-462">
                  <div data-id="element-463">
                    <h3 className="font-semibold text-gray-800 dark:text-gray-200 mb-2" data-id="element-464">
                      2.1 Core Services
                    </h3>
                    <p className="text-gray-600 dark:text-gray-400 mb-2" data-id="element-465">
                      We provide the following services:
                    </p>
                    <ul className="list-disc list-inside text-gray-600 dark:text-gray-400 space-y-1 ml-4" data-id="element-466">
                      <li data-id="element-467">MVP development</li>
                      <li data-id="element-468">Go-to-market strategies</li>
                      <li data-id="element-469">Branding</li>
                      <li data-id="element-470">Recruiting</li>
                    </ul>
                  </div>
                  <div data-id="element-471">
                    <h3 className="font-semibold text-gray-800 dark:text-gray-200 mb-2" data-id="element-472">
                      2.2 Pricing Model
                    </h3>
                    <p className="text-gray-600 dark:text-gray-400 mb-2" data-id="element-473">
                      Our services are available under the following pricing
                      structures:
                    </p>
                    <ul className="list-disc list-inside text-gray-600 dark:text-gray-400 space-y-1 ml-4" data-id="element-474">
                      <li data-id="element-475">
                        Equity-Based Model: Clients may opt for a $0 upfront
                        payment in exchange for equity.
                      </li>
                      <li data-id="element-476">
                        Fixed-Pricing Model: A one-time payment of $10,000 for
                        the project.
                      </li>
                      <li data-id="element-477">
                        Other Payment Terms: Custom agreements can be made on a
                        case-by-case basis.
                      </li>
                    </ul>
                  </div>
                  <div data-id="element-478">
                    <h3 className="font-semibold text-gray-800 dark:text-gray-200 mb-2" data-id="element-479">
                      2.3 Service Process
                    </h3>
                    <p className="text-gray-600 dark:text-gray-400" data-id="element-480">
                      We follow a structured 7-step process for project
                      execution. Communication occurs through email, forms,
                      chatbots, and platform-based channels.
                    </p>
                  </div>
                  <div data-id="element-481">
                    <h3 className="font-semibold text-gray-800 dark:text-gray-200 mb-2" data-id="element-482">
                      2.4 Refund & Cancellation Policy
                    </h3>
                    <ul className="list-disc list-inside text-gray-600 dark:text-gray-400 space-y-1 ml-4" data-id="element-483">
                      <li data-id="element-484">
                        If the agreement includes a cash payment, an upfront
                        deposit of $1,000 USD is required to initiate
                        implementation.
                      </li>
                      <li data-id="element-485">
                        The remaining payment is due upon acceptance of the
                        final deliverable.
                      </li>
                      <li data-id="element-486">
                        If the client does not sign the acceptance, no final
                        payment is required, and the project will not be
                        completed.
                      </li>
                      <li data-id="element-487">
                        No refunds will be issued once work has commenced.
                      </li>
                    </ul>
                  </div>
                </div>
              </section>
              <section data-id="element-488">
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4" data-id="element-489">
                  3. User Responsibilities
                </h2>
                <div className="space-y-4" data-id="element-490">
                  <div data-id="element-491">
                    <h3 className="font-semibold text-gray-800 dark:text-gray-200 mb-2" data-id="element-492">
                      3.1 Who Can Use the Service?
                    </h3>
                    <p className="text-gray-600 dark:text-gray-400" data-id="element-493">
                      Our services are available to individuals aged 13 and
                      above.
                    </p>
                  </div>
                  <div data-id="element-494">
                    <h3 className="font-semibold text-gray-800 dark:text-gray-200 mb-2" data-id="element-495">
                      3.2 Client Obligations
                    </h3>
                    <p className="text-gray-600 dark:text-gray-400 mb-2" data-id="element-496">
                      Clients must:
                    </p>
                    <ul className="list-disc list-inside text-gray-600 dark:text-gray-400 space-y-1 ml-4" data-id="element-497">
                      <li data-id="element-498">
                        Provide all necessary project details in a timely
                        manner.
                      </li>
                      <li data-id="element-499">
                        Engage in regular collaboration, including weekly calls.
                      </li>
                      <li data-id="element-500">Sign off on project deliverables and acceptance.</li>
                      <li data-id="element-501">Complete payments according to the agreed terms.</li>
                    </ul>
                  </div>
                  <div data-id="element-502">
                    <h3 className="font-semibold text-gray-800 dark:text-gray-200 mb-2" data-id="element-503">
                      3.3 Code Ownership
                    </h3>
                    <p className="text-gray-600 dark:text-gray-400" data-id="element-504">
                      The Intellectual Property (IP) rights of the final MVP
                      belong to the client once all payments and equity
                      agreements are fulfilled.
                    </p>
                  </div>
                </div>
              </section>
              <section data-id="element-505">
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4" data-id="element-506">
                  4. Liability & Disclaimers
                </h2>
                <div className="space-y-4" data-id="element-507">
                  <div data-id="element-508">
                    <h3 className="font-semibold text-gray-800 dark:text-gray-200 mb-2" data-id="element-509">
                      4.1 Limitation of Liability
                    </h3>
                    <p className="text-gray-600 dark:text-gray-400 space-y-2" data-id="element-510">
                      <p data-id="element-511">
                        MVPHub provides its services "as-is" and assumes no
                        liability for project delays, failures, or third-party
                        issues.
                      </p>
                      <p data-id="element-512">
                        MVPHub will not be responsible for any losses, damages,
                        or missed opportunities arising from the use of our
                        services.
                      </p>
                    </p>
                  </div>
                  <div data-id="element-513">
                    <h3 className="font-semibold text-gray-800 dark:text-gray-200 mb-2" data-id="element-514">
                      4.2 No Guarantees
                    </h3>
                    <p className="text-gray-600 dark:text-gray-400" data-id="element-515">
                      We do not guarantee funding, success, or market adoption
                      of the MVP or any related services.
                    </p>
                  </div>
                </div>
              </section>
              <section data-id="element-516">
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4" data-id="element-517">
                  5. Confidentiality & Intellectual Property (IP)
                </h2>
                <div className="space-y-4" data-id="element-518">
                  <div data-id="element-519">
                    <h3 className="font-semibold text-gray-800 dark:text-gray-200 mb-2" data-id="element-520">
                      5.1 Intellectual Property Rights
                    </h3>
                    <ul className="list-disc list-inside text-gray-600 dark:text-gray-400 space-y-1 ml-4" data-id="element-521">
                      <li data-id="element-522">
                        The client owns all customizations and business logic
                        specific to their MVP.
                      </li>
                      <li data-id="element-523">
                        The MVP is built on MVPHub's rapid prototyping
                        framework, which will be delivered in a containerized
                        format.
                      </li>
                      <li data-id="element-524">
                        MVPHub provides a lifetime license for the use of this
                        framework but retains ownership of the underlying
                        platform.
                      </li>
                    </ul>
                  </div>
                  <div data-id="element-525">
                    <h3 className="font-semibold text-gray-800 dark:text-gray-200 mb-2" data-id="element-526">
                      5.2 Confidentiality
                    </h3>
                    <ul className="list-disc list-inside text-gray-600 dark:text-gray-400 space-y-1 ml-4" data-id="element-527">
                      <li data-id="element-528">
                        MVPHub will handle all client information and project
                        details with strict confidentiality.
                      </li>
                      <li data-id="element-529">
                        We will not disclose sensitive data without explicit
                        client consent unless required by law.
                      </li>
                    </ul>
                  </div>
                </div>
              </section>
              <section data-id="element-530">
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4" data-id="element-531">
                  6. Dispute Resolution
                </h2>
                <div className="space-y-4" data-id="element-532">
                  <div data-id="element-533">
                    <h3 className="font-semibold text-gray-800 dark:text-gray-200 mb-2" data-id="element-534">
                      6.1 Governing Law
                    </h3>
                    <p className="text-gray-600 dark:text-gray-400" data-id="element-535">
                      These Terms are governed by the laws of the State of
                      Delaware, USA.
                    </p>
                  </div>
                  <div data-id="element-536">
                    <h3 className="font-semibold text-gray-800 dark:text-gray-200 mb-2" data-id="element-537">
                      6.2 Arbitration Clause
                    </h3>
                    <p className="text-gray-600 dark:text-gray-400" data-id="element-538">
                      Any disputes arising from these Terms will first be
                      resolved through arbitration before pursuing litigation.
                    </p>
                  </div>
                </div>
              </section>
              <section data-id="element-539">
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4" data-id="element-540">
                  7. Amendments & Contact Information
                </h2>
                <div className="text-gray-600 dark:text-gray-400 space-y-2" data-id="element-541">
                  <p data-id="element-542">
                    MVPHub reserves the right to modify these Terms at any time.
                    Clients will be notified of any significant changes.
                  </p>
                  <p data-id="element-543">
                    For any questions or concerns regarding these Terms, please
                    contact us at{" "}
                    <a href="mailto:privacy@mvphub.co" className="text-blue-600 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300 underline" data-id="element-544">
                      privacy@mvphub.co
                    </a>
                    .
                  </p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </main>
    </div>;
}